export enum GATEWAY_UPDATE_STATUS {
  SUCCESS = 1,
  AVAILABLE = 2,
  PROGRESS = 3,
  PENDING = 4,
  ERROR = 5,
  NONE = 10
}
